<template>
  <div class="projects-box">
    <menuBox :step="4"></menuBox>
    <div class="title-box">
      <p>聯絡我們</p>
      <span>合作支援請與我們聯繫，我們將為您客製化產品解決方案</span>
    </div>
    <div class="connect-box">
      <div class="item">
        <img src="../assets/connectTel.png" class="connectTel" alt="">
        <div>
          <div class="title">電話聯系</div>
          <!-- <div class="text">xxxx官方咨询电话</div> -->
          <div class="bt">
            <img src="../assets/connectTel1.png" alt="">
            <p>66573407</p>
          </div>
        </div>
      </div>
      <div class="item">
        <img src="../assets/connectEmail.png" class="connectTel" alt="">
        <div>
          <div class="title">郵箱聯系</div>
          <!-- <div class="text">xxxx官方咨询电话</div> -->
          <div class="bt">
            <img src="../assets/connectEmail1.png" alt="">
            <p>seasonalveget@gmail.com</p>
          </div>
        </div>
      </div>
    </div>
    <div class="reserve-box">
      <div class="list">
        <div class="bt">預約諮詢</div>
        <div class="item"><span>·</span>專家一對一服務</div>
        <div class="item"><span>·</span>方便快速的預約系統</div>
        <div class="item"><span>·</span>客製化諮詢方案</div>
      </div>
      <div class="list">
        <div class="bt">線下諮詢</div>
        <div class="item"><span>·</span>親臨體驗專業建議</div>
        <div class="item"><span>·</span>現場問題解決支援</div>
        <div class="item"><span>·</span>實地評估與分析</div>
      </div>
      <div class="list">
        <div class="bt">成為合作夥伴</div>
        <div class="item"><span>·</span>互利的商業機會</div>
        <div class="item"><span>·</span>定期業務發展培訓</div>
        <div class="item"><span>·</span>全方位技術與市場支持</div>
      </div>
    </div>
    <div class="connectUs-box">
      <div class="title">留下您的聯系方式</div>
      <div class="text">我們是一家科技公司，擁有一支年輕國際化的團隊，成員來自世界各地，致力於為企業提供高品質，可用的產品和服務平臺，我們致力於幫助用戶擺脫沈重的IT
        和計算設施，將更多的經歷和資源聚焦在業務和服務本身</div>
      <div class="inputBox">
        <input type="text" placeholder="您的聯系方式">
        <div class="btn" @click="submit">提交</div>
      </div>

    </div>
    <footerBox></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "projects",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {
    };
  },
  mounted() { },
  methods: {
    submit() {
      alert('success!')
    }
  },
};
</script>
<style lang="less" scoped>
.projects-box {
  .title-box {
    background-image: url(../assets/aboutUs.png);
    width: 100%;
    height: 580px;
    background-size: 100% 100%;
    overflow: hidden;
    padding: 279px 360px 0 360px;
    text-align: center;
    box-sizing: border-box;

    p {
      margin-bottom: 15px;
      font-size: 54px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 63px;
    }

    span {
      font-size: 28px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 33px;
    }

  }

  .connect-box {
    padding: 160px 360px;
    display: flex;
    justify-content: space-between;

    .item {
      display: flex;
      align-items: center;
      background: #FFFFFF;
      box-shadow: 3px 1px 44px 0px rgba(200, 216, 223, 0.47);
      margin-right: 60px;
      padding: 90px 110px 72px 45px;
      box-sizing: border-box;

      .connectTel {
        margin-right: 50px;
        width: 155px;
        height: 155px;
      }

      .title {
        margin-bottom: 10px;
        font-size: 32px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 600;
        color: #333333;
      }

      .text {
        margin-bottom: 24px;
        font-size: 24px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 28px;
      }

      .bt {
        display: flex;
        align-items: center;

        img {
          margin-right: 10px;
          width: 30px;
          height: 30px;
        }

        p {
          font-size: 24px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          color: #2C85FA;
        }
      }
    }

    .item:nth-child(2) {
      margin-right: 0;
    }
  }

  .reserve-box {
    display: flex;
    justify-content: space-between;
    padding: 0 360px 217px;
    box-sizing: border-box;

    .list {
      padding: 0 70px;
      border-right: 1px solid rgba(153, 153, 153, 0.6);

      .bt {
        margin-bottom: 24px;
        font-size: 32px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 600;
        color: #333333;
      }

      .item {
        margin-bottom: 27px;
        font-size: 20px;
        font-family: PingFang SC, PingFang SC;
        color: rgba(134, 131, 131, 1);

        span {
          color: rgba(44, 133, 250, 1);
        }
      }
    }

    .list:nth-child(1) {
      padding-left: 0;
    }

    .list:nth-child(3) {
      padding-right: 0;
      border: none;
    }
  }

  .connectUs-box {
    margin: 0 360px 116px;
    background-image: url(../assets/connectUs.png);
    height: 442px;
    background-size: 100% 100%;
    padding: 80px 290px 0;
    overflow: hidden;
    text-align: center;
    box-sizing: border-box;

    .title {
      margin-bottom: 24px;
      font-size: 48px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 58px;
    }

    .text {
      margin-bottom: 36px;
      font-size: 16px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.6);
      line-height: 28px;
    }

    .inputBox {
      position: relative;
      width: 480px;
      margin: 0 auto;

      input {
        width: 480px;
        padding: 32px;
        background: #FFFFFF;
        border-radius: 8px 8px 8px 8px;
        border: none;
        box-sizing: border-box;
      }

      .btn {
        position: absolute;
        right: 16px;
        bottom: 16px;
        display: table;
        padding: 15px 28px;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        background: #2C85FA;
        border-radius: 80px 80px 80px 80px;
        cursor: pointer;
      }
    }
  }
}
</style>
